<div id="global-loader" style="display: none">
  <div class="page-loader"></div>
</div>

<!-- <div class="custom-loader-wrapper">
  <div class="custom-loader"></div>
  <p>Loading...</p>
</div> -->
